var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMvpEmptyState = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 582,
    height: 168,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.299
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#BEC6C4",
    strokeDasharray: "0,3",
    d: "M1 7h550"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BEC6C4",
    d: "M1 127.5h550"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BEC6C4",
    strokeDasharray: "0,3",
    d: "M1 97.5h550M1 67.5h550M1 37.5h550"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BEC6C4",
    d: "M14.5 126.5V6.5M97.5 126.5V6.5M181.5 126.5V6.5M264.5 126.5V6.5M347.5 126.5V6.5M431.5 126.5V6.5M514.5 126.5V6.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#99D6EA",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m551 32.611-4.745-1.576-5.55 3.447-5.819-1.871-5.55-5.166h-5.237l-8.341-1.793-12.665 1.793-6.129-3.08-4.419-4.184-3.523 2.792-5.034-2.792-7.926 7.264-8.71-1.793-5.201 1.679-8.474 7.151-5.139-1.871-4.148-8.246-4.75 3.08-7.948.742-5.655 1.326-4.493 10.771-3.87-4.912-4.918 14.495h-4.642l-4.428-4.01-4.613 4.01-3.921-1.215-5.262 4.083h-4.365l-8.904 3.649-3.561 5.173-4.239-1.025-6.124 2.605-7.627 19.7-4.926.893-4.828-3.222-4.377 5.326-4.635-1.009-5.257 1.009h-3.445l-3.931 5.406-4.975-1.643h-4.201l-4.007 4.007-5.05-4.878-3.996 3.399-5.289-7.3-11.976 3.901-9.816-3.901-4.593-4.317-10.176 5.326-8.074 1.19-3.308 4.216-4.862-2.514-5.275.871-8.557 7.235h-4.027l-8.234 3.039-5.623-2.037-4.514 2.037-4.399-6.267-3.867 5.167-4.999-4.024-4.911 3.087h-5.212l-7.719 7.612-5.104-2.007-3.885 2.007-5.012-2.007-4.671-12.199-3.543 7.531-9.033 6.675-4.98-9.324-8.558 5.15-4.882-6.525-5.078 5.124h-8.366l-6.955-3.749-6.426.71-4.371-7.235-4.751 2.528-4.29-3.399-4.658 2.514-4.974-5.406-4.171 5.406H68.3l-4.25-10.732h-5.258l-3.77 6.516-4.575-4.187-3.772 4.187-5.122 2.573H36.07l-7.138 2.528-10.919-.885-7.604 4.882-5.42-3.997L1 94.747"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#545454",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 12
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(1 131)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 500.526,
    y: 11
  }, "2021")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1 131)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11
  }, "2015")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1 131)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 83.421,
    y: 11
  }, "2016")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1 131)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 166.842,
    y: 11
  }, "2017")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1 131)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 250.263,
    y: 11
  }, "2018")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1 131)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 333.684,
    y: 11
  }, "2019")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1 131)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 417.105,
    y: 11
  }, "2020"))), /*#__PURE__*/React.createElement("text", {
    fill: "#545454",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 12,
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 554,
    y: 11
  }, "$13k")), /*#__PURE__*/React.createElement("text", {
    fill: "#545454",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 12,
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 554,
    y: 131
  }, "$9k")), /*#__PURE__*/React.createElement("text", {
    fill: "#545454",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 12,
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 554,
    y: 101
  }, "$10k")), /*#__PURE__*/React.createElement("text", {
    fill: "#545454",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 12,
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 554,
    y: 71
  }, "$11k")), /*#__PURE__*/React.createElement("text", {
    fill: "#545454",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 12,
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 554,
    y: 41
  }, "$12k"))), /*#__PURE__*/React.createElement("text", {
    fill: "#505759",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 12,
    transform: "translate(169 60)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0.358,
    y: 11
  }, "Select view more detail to access charts")))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMvpEmptyState);
export default ForwardRef;